import { render, staticRenderFns } from "./MockRecord.vue?vue&type=template&id=24cb907c&scoped=true&"
import script from "./MockRecord.vue?vue&type=script&lang=js&"
export * from "./MockRecord.vue?vue&type=script&lang=js&"
import style0 from "./MockRecord.vue?vue&type=style&index=0&id=24cb907c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb907c",
  null
  
)

export default component.exports